import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleReturn.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleReturn' */ './component')],
	render: ([AdminBicycleReturn]) => <AdminBicycleReturn />,
};

export default routes;
